import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavBar, SideBar } from "../../components/admin";
import { useDispatch, useSelector } from "react-redux";
import { reset } from "../../features/authSlice";

const AdminLayout = ({ children }) => {
  const [handleNavbar, setHandleNavbar] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.auth);

  useEffect(() => {
    if (data?.data?.status === "0") {
      navigate("/verification");
    }
  }, [data, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    dispatch(reset());
    navigate("/");
  };
  return (
    <div>
      <div className="main-container">
        <SideBar
          handleLogout={handleLogout}
          setHandleNavbar={setHandleNavbar}
          handleNavbar={handleNavbar}
        />
        <main className="content">
          <NavBar />

          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
